import Catalog from 'src/ccm/careflow/rounding/Model/Catalog';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import Bed from 'src/ccm/careflow/rounding/Model/Bed';
import BedAssignment from 'src/ccm/careflow/rounding/Model/BedAssignment';

export type BedPaginationType = {
  take: number;
  skip: number;
}

export type getBedsPropsType = {
  search: string | null;
  status?: string;
  locationFhirId?: string | null;
  pagination: BedPaginationType
}

export type CensusSaveBedPropsType = {
  id?: number;
  status: boolean;
  locationFhirId: string;
  locationFhirName: string;
  identifier: string;
  createdByName: string;
}

export async function getBeds({
  search,
  status,
  locationFhirId,
  pagination, 
}: getBedsPropsType) {
  const data = await apiClient.get<{ beds: Bed[]; total: number }>(
    `/ccm/rounding/bed/list?status=${status}&search=${search}&take=${pagination?.take}&skip=${pagination?.skip}&location=${locationFhirId}`
  );

  return data;
}

export async function getBedExitDestinations() {
  const data = await apiClient.get<Catalog[]>(`/ccm/rounding/bed/exit-destionations`);

  return data;
}

export async function getCurrentBedAssignment(patientFhirId: string) {
  const data = await apiClient.get<BedAssignment>(`/ccm/rounding/bed/current-assignment/${patientFhirId}`);

  return data;
}

export async function getLocationHistory(patientFhirId: string) {
  const data = await apiClient.get<BedAssignment[]>(`/ccm/rounding/bed/location-history/${patientFhirId}`);

  return data;
}

export async function censusSaveBed(params: CensusSaveBedPropsType) {
  let url = `ccm/rounding/bed/save`
  if (params.id) {
    url = `ccm/rounding/bed/save/${params.id}`;
  }
  const data = await apiClient.post<any, Bed>(url, {
    ...params 
  });

  return data;
}